import React from 'react';
import mainImage from './data/main-image-mobile.jpg';

export const MobileAbout = () => {
  return (
    <div className="mobile-about">
      <div className="mobile-about-heading">
        <p>Юрист</p>
        <p>Володимир Красіловський</p>
      </div>
      <div className="mobile-about-content">
        <div className="mobile-about-border-block"></div>
        <div className="mobile-about-image">
          <img src={mainImage} alt="" />
        </div>
        <div className="mobile-about-text">
          <p className="mobile-about-text-heading">Сімейне право</p>
          <div>
            <p className="mobile-about-text-text">
              Досвід: 900+ виграних справ
            </p>
            <p className="mobile-about-text-text">Працюю по всій Україні</p>
          </div>
        </div>
      </div>
    </div>
  );
};
